<template>
  <div class="navbar-fixed" style="z-index: 9999;">
    <nav>
      <div class="nav-wrapper" :style="'background-color: ' + this.$store.state.empresa.cor_primaria" style="height: 106%">
<!--        <a data-target="slide-out" class="sidenav-trigger show-on-large waves-effect"><i class="material-icons" style="line-height: 40px;">menu</i></a>-->

        <i
          data-target="slide-out"
          v-if="compartilhar"
          class="icone fas fa-bars left sidenav-trigger show-on-large"
        ></i>

        <a class="brand-logo">
          <div align="center"><img src="https://res.cloudinary.com/sirrus/image/upload/v1606568320/delivery/modas/assets/logo_yxqfgw.png" class="logo"></div>
        </a>
        <i
        v-if="compartilhar"
        style="padding-right: 15px;"
        class="icone fas fa-share-alt right modal-trigger" href="#modal1"
      ></i>
        <ul id="slide-out" class="sidenav " :style="'background-color: ' + this.$store.state.empresa.cor_primaria">
          <li>
            <div class="user-view">
              <a href="">
                <img src="https://res.cloudinary.com/sirrus/image/upload/v1606568320/delivery/modas/assets/logo_yxqfgw.png" class="logo">
              </a>
            </div>
          </li>
          <li>
            <a href="#!" style="padding: 0 15px;font-size: medium" class="cor-fonte-menu-lateral">
              Departamentos</a>
          </li>
          <li>
            <div class="divider"></div>
          </li>
          <span v-for="grupo in grupos" :key="'menugrupomobi-'+grupo.grupo.id" class="cor-fonte-menu-lateral">
            <li class="">
              <ul class="collapsible collapsible-accordion ">
                <li>
                  <a class="collapsible-header waves-effect" style="color: white;    padding: 0px;">

                    <div class="row " style="    margin-bottom: 0px;">
                      <div class="col s2">
<!--                        <i class="material-icons" style="color: white">arrow_drop_down</i>-->
                        <i class="material-icons cor-fonte-menu-lateral">arrow_drop_down</i>
                      </div>
                      <div class="col s9">
<!--                        <span class="fonteMenu ">{{grupo.grupo.nome}}</span>-->
                        <span class="cor-fonte-menu-lateral ">{{grupo.grupo.nome}}</span>
                      </div>
                    </div>
                  </a>
                  <div class="collapsible-body collapsible-body-color-up" >
                    <ul>
                       <li v-for="secao in grupo.secoes">
                         <a @click="detalhes(grupo,secao.detalhes)" class="waves-effect cor-fonte-menu-lateral">
                           <i class="material-icons cor-fonte-menu-lateral" >label</i>{{secao.detalhes.nome}}</a>
                       </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </li>
          </span>
        </ul>
      </div>
      <slot></slot>
    </nav>
  </div>
</template>

<script>
import SecureLS from "secure-ls";

export default {
  name: "NavBar",
  props:["grupos","compartilhar"],
  updated() {
    $(document).ready(function(){
      $('.dropdown-trigger').dropdown();
      $('.collapsible').collapsible();
    });

    if (document.getElementsByClassName("collapsible-body-color-up")) {
      var itens = document.getElementsByClassName("collapsible-body-color-up");
      for (let i = 0; i <= itens.length; i++) {
        if (document.getElementsByClassName("collapsible-body-color-up")[i]) {
          document.getElementsByClassName("collapsible-body-color-up")[i].style = "background-color: " + this.$store.state.empresa.cor_primaria;
        }
      }
    }
  },
  methods:{
    detalhes(grupo,secao = null)
    {
      $('.sidenav').sidenav('close');
      var ls = new SecureLS();
      ls.set('grupo',grupo);
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/grupo/' + grupo.grupo.nome + '/secao/' + ( secao != null ? secao.id : 0 ));
    },
    Pesquisar(){
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/pesquisar')
    }
  }
}
</script>

<style scoped>


.fonteMenu{
  font-size: small;
}

.sidenav li > a > i, .sidenav li > a > [class^="mdi-"], .sidenav li > a li > a > [class*="mdi-"], .sidenav li > a > i.material-icons {
  float: left;
  height: 48px;
  line-height: 48px;
  margin: 0 25px 0 0;
  width: 10px;
  color: rgba(0, 0, 0, 0.54);
}

.logo {
  padding: 9px;
  width: 210px;
}

@media only screen and (max-width : 992px) {
  .logo {
    padding-top: 8px;
    width: 185px;
  }
}

.sidenav li > a {
  color: white;
}

  @media only screen and (max-width : 700px) {
    .icone{
      padding-top: 15px;
    }
  }

  @media only screen and (max-width : 440px) {
    .icone{
      padding-top: 15px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/app/views/template/NavBar.vue